import { render, staticRenderFns } from "./ImprovementIdeaPrintView.vue?vue&type=template&id=6287dbd5&scoped=true"
import script from "./ImprovementIdeaPrintView.vue?vue&type=script&lang=js"
export * from "./ImprovementIdeaPrintView.vue?vue&type=script&lang=js"
import style0 from "./ImprovementIdeaPrintView.vue?vue&type=style&index=0&id=6287dbd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287dbd5",
  null
  
)

export default component.exports